import { render, staticRenderFns } from "./anji.vue?vue&type=template&id=545657c2&"
import script from "./anji.vue?vue&type=script&lang=js&"
export * from "./anji.vue?vue&type=script&lang=js&"
import style0 from "./anji.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports